exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_toastContainer_3evPa {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n}\n\n.index_toastContainer_3evPa .index_toastContent_3TR0O {\n  margin: auto;\n  width: 400px;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 2px;\n  padding: 24px 56px;\n  color: #fff;\n  font-size: 14px;\n  line-height: 16px;\n}\n", ""]);

// Exports
exports.locals = {
	"toastContainer": "index_toastContainer_3evPa",
	"toastContent": "index_toastContent_3TR0O"
};